import React from "react";
import FormNestedCheckboxFieldGroup from "shared/form/fields/nestedCheckboxFieldGroup";
import DynamicFieldConfigType from "../types/DynamicFieldConfigType";
import SchemaService from "../SchemaService";
import DynamicFieldLabel from "./DynamicFieldLabel";
import { FormFieldOption } from "shared/form/fields/types";
import { useStaticData } from "context/staticData";
import { getNestedOptionsWithConflictTagType } from "shared/form/util";
import { FormValueType } from "../types/SchemaField";

export default function NestedCheckboxGroupFieldWrapper(props: DynamicFieldConfigType) {
  const staticData = useStaticData();
  const options: Array<FormFieldOption> = React.useMemo(() => {
    const parsedOptions = SchemaService.parseOptions({ schemaObj: props.schemaObj, staticData });
    return getNestedOptionsWithConflictTagType({
      options: parsedOptions,
      conflictValue: props.schemaObj.conflictValue as FormValueType,
      initialValue: props.schemaObj.value
    });
  }, [props.schemaObj, staticData]);

  const getConflictDisplayValue = React.useCallback(
    ({ value }) => {
      // filter out child options based on param value and remove options with 0 child options after filtering
      const filteredOptions = options
        .map(opt => ({ ...opt, childOptions: opt.childOptions?.filter(o => value.includes(o.value)) }))
        .filter(opt => opt.childOptions?.length);
      // for options that have child options, send parent and child option labels
      return filteredOptions.map(opt => ({ parent: opt.label, children: opt.childOptions?.map(o => o.label) }));
    },
    [options]
  );

  return (
    <FormNestedCheckboxFieldGroup
      name={props.schemaObj.id}
      label={<DynamicFieldLabel schemaObj={props.schemaObj} />}
      disabled={props.schemaObj.disabled}
      options={options}
      required={props.schemaObj.mandatory}
      validate={props.validationFn}
      withSelectAll={false}
      fieldOptionViewType={props.schemaObj.fieldOptionViewType}
      searchEnabled={false}
      conflictValue={props.schemaObj.conflictValue}
      customDisplayValue={getConflictDisplayValue}
      fullWidth={props.schemaObj.fullWidthView}
      indented={props.schemaObj.indented}
      openAccordionsWithConflicts={false}
    />
  );
}
